import { useEffect, useState } from "react";
import ChipWithCount from "../../../../../../components/ChipWithCount/ChipWithCount";
import {
  AssessmentButton,
  Bullets,
  RightSidePanel,
  useClickOutsideListenerRef,
  Tooltip,
  showToast,
  InputField,
} from "ui-components";
import { useTranslation } from "react-i18next";
import {
  capitalizeFirstLetter,
  handleDownloadDocument,
  removeFromQueryParams,
  setInQueryParams,
} from "../../../../../../utils/Common/Constant";
import ScoreCalculationSidebar from "./ScoreCalculationSidebar/ScoreCalculationSidebar";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "../../../../../../components/Loader/Loader";
import AiStarIcon from "../../../../../../utils/Images/AiStarIcon";
import CreateContractForm from "../../../../components/CreateContractForm/CreateContractForm";
import CustomModal from "../../../../../../components/CustomModal/CustomModal";
import DownloadCVIcon from "../../../../../../utils/Images/DownloadCVIcon";
import {
  approveDocStatus,
  reviewDocuments,
  staffAugSettingsDetails,
} from "../../../../../../service/Settings/Settings";
import PdfIcon from "../../../../../../utils/Images/PdfIcon";
import PngIcon from "../../../../../../utils/Images/PngIcon";
import DocIcon from "../../../../../../utils/Images/DocIcon";
import DocxIcon from "../../../../../../utils/Images/DocxIcon";
import { CommonEnums } from "../../../../../../utils/Enums/CommonEnums";
import JPGIcon from "../../../../../../utils/Images/JPGIcon";
import CircleCrossIcon from "../../../../../../utils/Images/CircleCrossIcon";

const Content = ({
  item,
  setInvitedEmail,
  setIsInvited,
  jobId,
  tabActive,
  scoreCalculationSideBar,
  setScoreCalculationSideBar,
  handleScanCV,
  scanningCvIds,
  loading,
  jobTitle,
  cvListFunData,
  contractDocPopup,
  setContractDocPopup,
  showDocument,
  setShowDocument,
}: any) => {
  const { t } = useTranslation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const [scoreCalculation, setScoreCalculation] = useState([]);
  const [searchParams] = useSearchParams();
  const [showCreateContractPanel, setShowCreateContractPanel] = useState(false); // Added state
  const [remarkInput, setRemarkInput] = useState<{ [key: string]: string }>({});
  const [showRemarkField, setShowRemarkField] = useState<{
    [key: string]: boolean;
  }>({});
  const [closing, setClosing] = useState<{ [key: string]: boolean }>({});
  const [reviewStatus, setReviewStatus] = useState<{ [key: string]: string }>(
    {},
  );
  const [settingDetails, setSettingDetails] = useState<any>(null);
  useEffect(() => {
    if (searchParams.get("showFormulaPopup") === item?.refId) {
      setScoreCalculation(JSON.parse(item?.calcualationParameter) ?? []);
    }
  }, []);

  const getSettingsDetailsApi = async () => {
    try {
      const res = await staffAugSettingsDetails();
      if (res?.status === 200) {
        setSettingDetails(res?.data);
      }
    } catch (error) {
      console.error("Error fetching settings details:", error);
    }
  };
  // Button click handler
  const handleOpenContractPanel = async () => {
    await getSettingsDetailsApi();
    setShowCreateContractPanel(true);
  };
  // reviewDocument api
  const handleReview = async (
    status: "approved" | "rejected",
    staffAugumentationDocumentId: string,
    remark: string = "",
  ) => {
    try {
      const payload = {
        staffAugumentationDocumentId: [staffAugumentationDocumentId],
        status,
        remark: status === CommonEnums.STATUS_REJECTED ? remark : "",
      };
      const res = await reviewDocuments(payload);
      showToast(res?.customMessage, "success");
      // set active status for this document
      setReviewStatus((prev) => ({
        ...prev,
        [staffAugumentationDocumentId]: status,
      }));

      // hide remark field after saving
      setShowRemarkField((prev) => ({
        ...prev,
        [staffAugumentationDocumentId]: false,
      }));
    } catch (err) {
      console.error("Error reviewing document:", err);
    }
  };

  // approveDocStatus
  const allApproved =
    item?.contractDocuments?.length > 0 &&
    item?.contractDocuments?.every(
      (doc: any) =>
        reviewStatus[doc?.staffAugumentationDocumentId] ===
          CommonEnums.STATUS_APPROVED ||
        doc?.status === CommonEnums.STATUS_APPROVED,
    );

  const handleSave = async () => {
    try {
      const payload = {
        jobcontractId: item?.jobContractsId,
        status: "Active",
      };

      const res = await approveDocStatus(payload);
      if (res) {
        showToast(res?.customMessage, "success");
        removeFromQueryParams(queryParams, "reviewDoc", navigate);
        setContractDocPopup(null);
      }
    } catch (error) {
      console.error("Error starting contract:", error);
    }
  };

  return (
    <>
      {item?.scanStatus == "scanned" && (
        <>
          <div className="horizontalLine"></div>
          <div className="content mt-3" key={jobId}>
            <div className="w-100">
              <div className="w-100 mb-4">
                <p className="common">
                  {t("RESUME.SCANNING_EXPERIENCE")}
                  <span className="commonBold">
                    &nbsp;
                    {tabActive === "unscannedcv"
                      ? ""
                      : item?.expRelevancy !== null
                        ? item.expRelevancy + "%"
                        : ""}
                  </span>
                </p>
                <span className="words">
                  {item?.totalExp ? `${item?.totalExp} Years` : <h5>-</h5>}
                </span>
              </div>
              <div>
                <p className="common">
                  {t("RESUME.SCANNING_KEYWORDS")}
                  <span className="commonBold">
                    &nbsp;
                    {item?.keywordsRelevancy !== null
                      ? item.keywordsRelevancy + "%"
                      : ""}
                  </span>
                </p>
                <div className="words">
                  <SkillList item={item?.relevantKeywords} />
                </div>
              </div>
            </div>
            <div className="w-100">
              <div className="w-100 mb-4">
                <p className="common">
                  {t("GENERAL.MATCHED_SKILLS")}
                  <span className="commonBold">
                    &nbsp;
                    {tabActive === "unscannedcv"
                      ? ""
                      : item?.skillRelevancy !== null
                        ? item.skillRelevancy + "%"
                        : ""}
                  </span>
                </p>
                {tabActive === "unscannedcv" ? (
                  <h5>-</h5>
                ) : (
                  <SkillList item={item?.relevantSkills} />
                )}
              </div>
              <div>
                <p className="common">
                  {t("RESUME.SCANNING_PROJECTS")}
                  <span className="commonBold">
                    &nbsp;
                    {item?.projectsRelevancy !== null
                      ? item.projectsRelevancy + "%"
                      : ""}
                  </span>
                </p>
                <SkillList item={item?.projectRelevantSkills} />
              </div>
            </div>

            <div className="w-100 d-flex flex-column">
              <div className="w-100 mb-4">
                <p className="common">{t("GENERAL.UNMATCHED_SKILLS")}</p>
                {tabActive === "unscannedcv" ? (
                  <h5>-</h5>
                ) : (
                  <SkillList
                    item={item?.unmatchedSkill}
                    className={"unscannedcvs"}
                  />
                )}
              </div>
              <div>
                <p className="common relevantProject">
                  {t("RESUME.SCANNING_RELEVANT_PROJECTS")}{" "}
                  <span className="commonBold">&nbsp;</span>
                </p>
                <span className="words">
                  {item?.relevantProjectsCount ? (
                    item?.relevantProjectsCount
                  ) : (
                    <h5>-</h5>
                  )}
                </span>
              </div>
            </div>

            <div className="w-100 overAll">
              <p className="">{t("RESUME.ASSESSMENT_OVERALL")}</p>
              <span
                className="overAllScore cursorPointer"
                onClick={() => {
                  setScoreCalculation(
                    JSON.parse(item?.calcualationParameter) ?? [],
                  );
                  setScoreCalculationSideBar(item?.refId);
                  setInQueryParams(
                    queryParams,
                    "showFormulaPopup",
                    item?.refId,
                    navigate,
                  );
                }}
              >
                {item?.overAllRelevancy !== null ? (
                  `${item?.overAllRelevancy}%`
                ) : (
                  <h5>-</h5>
                )}
              </span>
            </div>
            <RightSidePanel
              className="rightSidePanelSection jobTheme"
              show={scoreCalculationSideBar === item?.refId}
              handleClose={() => {
                setScoreCalculationSideBar(null);
                removeFromQueryParams(
                  queryParams,
                  "showFormulaPopup",
                  navigate,
                );
              }}
              title={""}
            >
              <ScoreCalculationSidebar
                data={item}
                scoreCalculation={scoreCalculation}
              />
            </RightSidePanel>
          </div>
        </>
      )}
      <div className="d-flex gap-3 bottomBtns">
        <div className="otherButtonsCvList">
          <CustomModal
            show={showDocument === item?.jobApplicationId}
            isCrossBtn={true}
            isHeaderVisible={false}
            handleClose={() => {
              setShowDocument(null);
              removeFromQueryParams(queryParams, "reviewVendorDoc", navigate);
            }}
            size="lg"
            fullscreen="md-down"
            isFooterVisible={false}
            className="attachDocumentModal jobDocModal"
          >
            <div className="documentBodySec">
              <div>
                {item?.resourceDocuments.length ? (
                  <>
                    <h5>
                      {t("EVENT.EVENT_AT_START_OF_JOB_APPLICATION")} (
                      {item?.firstName})
                    </h5>
                    {item?.resourceDocuments?.map((doc: any, index: number) => (
                      <div className="documentModalBody" key={index}>
                        <div className="documentHead gap-2">
                          <div>
                            <div className="inlinePreviewContainer">
                              {doc?.fileExt === CommonEnums.EXTENSION_PDF ? (
                                <PdfIcon />
                              ) : doc?.fileExt === CommonEnums.EXTENSION_PNG ? (
                                <PngIcon />
                              ) : doc?.fileExt === CommonEnums.EXTENSION_DOC ? (
                                <DocIcon />
                              ) : doc?.fileExt ===
                                CommonEnums.EXTENSION_DOCX ? (
                                <DocxIcon />
                              ) : (
                                <JPGIcon />
                              )}
                            </div>
                          </div>
                          <div>
                            <h3>{doc?.title}</h3>
                            <div className="attachInputDownload">
                              <a
                                href={doc?.filePath}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {doc?.fileName}
                              </a>
                              <div
                                onClick={() =>
                                  handleDownloadDocument(
                                    doc?.filePath,
                                    doc?.fileName,
                                  )
                                }
                              >
                                <DownloadCVIcon />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="documentHeadBtn">
                          {reviewStatus[doc?.staffAugumentationDocumentId] ===
                            CommonEnums.STATUS_APPROVED ||
                          doc?.status === CommonEnums.STATUS_APPROVED ? (
                            <AssessmentButton className="statusText approved">
                              {t("SETTING.APPROVED")}
                            </AssessmentButton>
                          ) : reviewStatus[
                              doc?.staffAugumentationDocumentId
                            ] === CommonEnums.STATUS_REJECTED ||
                            doc?.status === CommonEnums.STATUS_REJECTED ? (
                            <AssessmentButton className="statusText rejected">
                              {t("VENDOR.REJECTED")}
                            </AssessmentButton>
                          ) : showRemarkField[
                              doc?.staffAugumentationDocumentId
                            ] ? (
                            <div
                              className={`remarkSec ${closing[doc?.staffAugumentationDocumentId] ? "fade-out" : "fade-in"}`}
                              onAnimationEnd={() => {
                                if (
                                  closing[doc?.staffAugumentationDocumentId]
                                ) {
                                  setShowRemarkField((prev) => ({
                                    ...prev,
                                    [doc?.staffAugumentationDocumentId]: false,
                                  }));
                                  setClosing((prev) => ({
                                    ...prev,
                                    [doc?.staffAugumentationDocumentId]: false,
                                  }));
                                }
                              }}
                            >
                              <div className="d-flex gap-1 mb-2">
                                <InputField
                                  placeholder={t("SETTING.REMARK")}
                                  value={
                                    remarkInput[
                                      doc?.staffAugumentationDocumentId
                                    ] || ""
                                  }
                                  onChange={(e: any) =>
                                    setRemarkInput((prev) => ({
                                      ...prev,
                                      [doc?.staffAugumentationDocumentId]: e,
                                    }))
                                  }
                                />
                                <AssessmentButton
                                  onClick={() =>
                                    handleReview(
                                      CommonEnums.STATUS_REJECTED,
                                      doc.staffAugumentationDocumentId,
                                      remarkInput[
                                        doc.staffAugumentationDocumentId
                                      ] || "",
                                    )
                                  }
                                  className="saveBtn whiteBtn"
                                  disabled={
                                    !remarkInput[
                                      doc.staffAugumentationDocumentId
                                    ]?.trim()
                                  }
                                >
                                  {t("GENERAL.SAVE")}
                                </AssessmentButton>
                                <AssessmentButton
                                  className="closeBtn"
                                  onClick={() =>
                                    setClosing((prev) => ({
                                      ...prev,
                                      [doc?.staffAugumentationDocumentId]: true,
                                    }))
                                  }
                                >
                                  <CircleCrossIcon />
                                </AssessmentButton>
                              </div>
                            </div>
                          ) : (
                            <>
                              <AssessmentButton
                                onClick={() =>
                                  handleReview(
                                    CommonEnums.STATUS_APPROVED,
                                    doc?.staffAugumentationDocumentId,
                                  )
                                }
                                className="approveBtn"
                              >
                                {t("GENERAL.APPROVE")}
                              </AssessmentButton>
                              <AssessmentButton
                                onClick={() =>
                                  setShowRemarkField((prev) => ({
                                    ...prev,
                                    [doc?.staffAugumentationDocumentId]: true,
                                  }))
                                }
                                className="rejectBtn"
                              >
                                {t("GENERAL.REJECT")}
                              </AssessmentButton>
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </CustomModal>
          {item?.resourceDocuments.length > 0 ? (
            <AssessmentButton
              className="whiteBtn"
              onClick={() => {
                setShowDocument(item?.jobApplicationId);
                setInQueryParams(
                  queryParams,
                  "reviewVendorDoc",
                  item?.jobApplicationId,
                  navigate,
                );
              }}
            >
              {t("SETTING.JOB_DOCUMENTS")}
            </AssessmentButton>
          ) : (
            ""
          )}
          {item?.scanStatus == "unscanned" &&
            !item?.isInvited &&
            (item?.source !== "vendor" ||
              (!item?.jobContractsId && !item?.contractStatus)) && (
              <div className="scanBtn">
                <AssessmentButton
                  className={
                    scanningCvIds?.includes(item?.refId) ? "" : "whiteBtn"
                  }
                  onClick={() => handleScanCV(jobId, "", item?.refId)}
                  disabled={scanningCvIds?.includes(item?.refId)}
                >
                  <AiStarIcon />
                  {scanningCvIds?.includes(item?.refId) ? (
                    <div className="btn-loader">
                      <span className="scanText">
                        {t("RESUME.ASSESSMENT_SCANNING_CV")}
                      </span>
                      <Loader />
                    </div>
                  ) : (
                    <span>{t("RESUME.SCANNING_SCAN_CV")}</span>
                  )}
                </AssessmentButton>
              </div>
            )}
          {/* progress loader when scan cv is in progress */}
          {item?.scanStatus == "inprogress" && (
            <div className="progressWrapper">
              <div className="progressContainer">
                <div className="progressBar">
                  <div className="progressStripes"></div>
                </div>
              </div>
            </div>
          )}
          {/* show invite button when not invited and not inprogress */}
          {item?.scanStatus !== "inprogress" &&
            !item?.isInvited &&
            (item?.source !== "vendor" ||
              (!item?.jobContractsId && !item?.contractStatus)) && (
              <div>
                <AssessmentButton
                  onClick={() => {
                    setInvitedEmail({
                      email: item?.email,
                      firstName: item?.firstName,
                      lastName: item?.lastName,
                    });
                    setIsInvited(item?.refId);
                    setInQueryParams(
                      queryParams,
                      "cvId",
                      item?.refId,
                      navigate,
                    );
                  }}
                  className="whiteBtn"
                  disabled={loading}
                >
                  {t("RESUME.INVITE_TO_ASSESSMENT")}
                </AssessmentButton>
              </div>
            )}

          {/* show invited text when isInvited true */}
          {item?.isInvited && (
            <div className="invitedText">
              <span>{t("GENERAL.INVITED")}</span>
              <div className="iIcon">
                <Tooltip
                  classname="tooltipOverCss"
                  text={t("GENERAL.ALREADY_INVITED")}
                />
              </div>
            </div>
          )}
          {item?.source === "vendor" && item?.scanStatus !== "inprogress" && (
            <>
              {!item?.jobContractsId && !item?.contractStatus && (
                <AssessmentButton
                  onClick={handleOpenContractPanel} // Updated onClick
                  className="whiteBtn"
                  disabled={loading}
                >
                  {t("CONTRACT.CREATE_CONTRACT_BUTTON")}
                </AssessmentButton>
              )}
              {item?.jobContractsId && item?.contractStatus == "Draft" && (
                <AssessmentButton
                  onClick={handleOpenContractPanel} // Updated onClick
                  className="whiteBtn"
                  disabled={loading}
                >
                  {t("CONTRACT.EDIT_CONTRACT")}
                </AssessmentButton>
              )}
            </>
          )}

          {/* Modal for Approve contract documents ----------------*/}

          {(item?.contractStatus === "Created" ||
            item?.contractStatus === "Review Pending") &&
            item?.contractDocuments?.length > 0 && (
              <AssessmentButton
                onClick={() => {
                  setContractDocPopup(item?.jobApplicationId);
                  setInQueryParams(
                    queryParams,
                    "reviewDoc",
                    item?.jobApplicationId,
                    navigate,
                  );
                }}
                className="whiteBtn"
                disabled={loading}
              >
                {t("SETTING.CONTRACT_DOCUMENTS")}
              </AssessmentButton>
            )}

          <CustomModal
            show={contractDocPopup === item?.jobApplicationId}
            isCrossBtn={true}
            isHeaderVisible={false}
            handleClose={() => {
              setContractDocPopup(null);
              removeFromQueryParams(queryParams, "reviewDoc", navigate);
            }}
            size="lg"
            fullscreen="md-down"
            isFooterVisible={false}
            className="attachDocumentModal reviewContractModal"
          >
            <div className="documentBodySec">
              <div>
                {item?.contractDocuments.length ? (
                  <>
                    <h5>
                      {t("EVENT.EVENT_AT_START_OF_CONTRACT_CREATION")} (
                      {item?.firstName})
                    </h5>
                    {item?.contractDocuments?.map((doc: any, index: number) => (
                      <div className="documentModalBody" key={index}>
                        <div className="documentHead gap-2">
                          <div className="inlinePreviewContainer">
                            {doc?.fileExt === CommonEnums.EXTENSION_PDF ? (
                              <PdfIcon />
                            ) : doc?.fileExt === CommonEnums.EXTENSION_PNG ? (
                              <PngIcon />
                            ) : doc?.fileExt === CommonEnums.EXTENSION_DOC ? (
                              <DocIcon />
                            ) : doc?.fileExt === CommonEnums.EXTENSION_DOCX ? (
                              <DocxIcon />
                            ) : (
                              <JPGIcon />
                            )}
                          </div>
                          <div>
                            <h3>{doc?.title}</h3>
                            <div className="attachInputDownload">
                              <a
                                href={doc?.filePath}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {doc?.fileName}
                              </a>
                              <div
                                onClick={() =>
                                  handleDownloadDocument(
                                    doc?.filePath,
                                    doc?.fileName,
                                  )
                                }
                              >
                                <DownloadCVIcon />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="documentHeadBtn">
                          {reviewStatus[doc?.staffAugumentationDocumentId] ===
                            CommonEnums.STATUS_APPROVED ||
                          doc?.status === CommonEnums.STATUS_APPROVED ? (
                            <AssessmentButton className="statusText approved">
                              {t("SETTING.APPROVED")}
                            </AssessmentButton>
                          ) : reviewStatus[
                              doc?.staffAugumentationDocumentId
                            ] === CommonEnums.STATUS_REJECTED ||
                            doc?.status === CommonEnums.STATUS_REJECTED ? (
                            <AssessmentButton className="statusText rejected">
                              {t("VENDOR.REJECTED")}
                            </AssessmentButton>
                          ) : showRemarkField[
                              doc?.staffAugumentationDocumentId
                            ] ? (
                            <div
                              className={`remarkSec ${closing[doc?.staffAugumentationDocumentId] ? "fade-out" : "fade-in"}`}
                              onAnimationEnd={() => {
                                if (
                                  closing[doc?.staffAugumentationDocumentId]
                                ) {
                                  setShowRemarkField((prev) => ({
                                    ...prev,
                                    [doc?.staffAugumentationDocumentId]: false,
                                  }));
                                  setClosing((prev) => ({
                                    ...prev,
                                    [doc?.staffAugumentationDocumentId]: false,
                                  }));
                                }
                              }}
                            >
                              <div className="d-flex gap-1 mb-2">
                                <InputField
                                  placeholder={t("SETTING.REMARK")}
                                  value={
                                    remarkInput[
                                      doc?.staffAugumentationDocumentId
                                    ] || ""
                                  }
                                  onChange={(e: any) =>
                                    setRemarkInput((prev) => ({
                                      ...prev,
                                      [doc?.staffAugumentationDocumentId]: e,
                                    }))
                                  }
                                />
                                <AssessmentButton
                                  onClick={() =>
                                    handleReview(
                                      CommonEnums.STATUS_REJECTED,
                                      doc.staffAugumentationDocumentId,
                                      remarkInput[
                                        doc.staffAugumentationDocumentId
                                      ] || "",
                                    )
                                  }
                                  className="saveBtn whiteBtn"
                                  disabled={
                                    !remarkInput[
                                      doc.staffAugumentationDocumentId
                                    ]?.trim()
                                  }
                                >
                                  {t("GENERAL.SAVE")}
                                </AssessmentButton>
                                <AssessmentButton
                                  className="closeBtn"
                                  onClick={() =>
                                    setClosing((prev) => ({
                                      ...prev,
                                      [doc?.staffAugumentationDocumentId]: true,
                                    }))
                                  }
                                >
                                  <CircleCrossIcon />
                                </AssessmentButton>
                              </div>
                            </div>
                          ) : (
                            <>
                              <AssessmentButton
                                onClick={() =>
                                  handleReview(
                                    CommonEnums.STATUS_APPROVED,
                                    doc?.staffAugumentationDocumentId,
                                  )
                                }
                                className="approveBtn"
                              >
                                {t("GENERAL.APPROVE")}
                              </AssessmentButton>
                              <AssessmentButton
                                onClick={() =>
                                  setShowRemarkField((prev) => ({
                                    ...prev,
                                    [doc?.staffAugumentationDocumentId]: true,
                                  }))
                                }
                                className="rejectBtn"
                              >
                                {t("GENERAL.REJECT")}
                              </AssessmentButton>
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  ""
                )}
              </div>
              {allApproved && (
                <div className="startContractModalBtn">
                  <AssessmentButton className="whiteBtn" onClick={handleSave}>
                    {t("CONTRACT.START_CONTRACT")}
                  </AssessmentButton>
                </div>
              )}
            </div>
          </CustomModal>
        </div>
      </div>

      {/* RightSidePanel for Create Contract Form */}
      {showCreateContractPanel && (
        <RightSidePanel
          show={showCreateContractPanel}
          handleClose={() => setShowCreateContractPanel(false)}
          title={
            item?.firstName && item?.lastName
              ? `${item?.firstName} ${item?.lastName}`
              : `${item?.email?.toLowerCase()}`
          }
          className="rightSidePanelSection jobTheme createContractPanel" // Added a specific class for styling if needed
        >
          <CreateContractForm
            onClose={() => setShowCreateContractPanel(false)}
            candidateId={item?.refId}
            data={{ ...item, jobTitle, jobId }}
            partnerCompanyId={item?.companyId}
            partnerUserId={item?.userId}
            cvListFunData={cvListFunData}
            jobcontractId={item?.jobContractsId ?? ""}
            contractReqs={settingDetails?.contractRequirements || []}
          />
        </RightSidePanel>
      )}
    </>
  );
};

export default Content;

export const SkillList = ({
  item,
  className,
}: {
  item: any;
  className?: any;
}) => {
  const [showAddMoreSkill, setShowAddMoreSkill] = useState(false);
  const addMoreSkillRef = useClickOutsideListenerRef(() => {
    setShowAddMoreSkill(false);
  });
  return (
    <div className={`skillList ${className}`}>
      {item?.length > 0 ? (
        <>
          {item
            ?.split(",")
            .slice(0, 3)
            .map((skill: any, ind: any) => (
              <div title={skill} key={ind} className="skillName">
                <Bullets skillName={capitalizeFirstLetter(skill)} />
              </div>
            ))}
          {item?.split(",").length > 3 && (
            <div className="dropdownWrapper" ref={addMoreSkillRef}>
              <div
                className="showMore"
                onClick={() => setShowAddMoreSkill(!showAddMoreSkill)}
              >
                <ChipWithCount noOfCount={item?.split(",").length - 3} />
              </div>
              {showAddMoreSkill && (
                <div className="dropdownMenu">
                  {item
                    ?.split(",")
                    .slice(3)
                    .map((skill: any, ind: any) => (
                      <div title={skill} key={ind} className="dropdownItem">
                        <Bullets skillName={capitalizeFirstLetter(skill)} />
                      </div>
                    ))}
                </div>
              )}
            </div>
          )}
        </>
      ) : (
        <h5>-</h5>
      )}
    </div>
  );
};
